import Chance from 'chance';
import moment from 'moment-timezone';
import { Utility } from '../../utility/index.js';
import formatter from '@knack/formatter';
import { getFakeDate } from './get-fake-date.js';
import { getFakeNumber } from './get-fake-number.js';
import { getFakeOther } from './get-fake-other.js';
import { getFakeText } from './get-fake-text.js';
const chance = new Chance();
const fieldCategoryMapping = Utility.initializeFieldCategoryMapping();
export const getSampleValueForField = (field, state, sampleOptions) => {
    const { fieldType } = field;
    let { fieldFormat } = field;
    let fieldCategory = fieldCategoryMapping[fieldType];
    let val;
    if (!fieldFormat) {
        fieldFormat = {};
    }
    if (!fieldCategory) {
        fieldCategory = `other`;
    }
    switch (fieldCategory) {
        case `choice`:
        case `file`:
        case `text`:
        case `personal`:
            val = getFakeText(fieldType);
            break;
        case `number`:
            val = getFakeNumber(fieldType, state);
            break;
        case `date`:
            val = getFakeDate(fieldType, state, sampleOptions);
            if (sampleOptions && sampleOptions.formatDateAsMoment) {
                return moment(val);
            }
            break;
        case `other`:
            val = getFakeOther(fieldType);
            break;
        default:
            val = chance.word();
            break;
    }
    const formatOptions = {
        s3: {
            urlBase: `fakedata.knack.com`
        },
        application: {
            getUserObject: () => {
                return {
                    name: chance.pickone([
                        `admin`,
                        `user`,
                        `trial`
                    ])
                };
            },
            getField: (fieldKey) => {
                return {
                    key: fieldKey,
                    type: `number`,
                    format: {}
                };
            }
        }
    };
    return formatter.valueFormatter.formatValue({
        type: fieldType,
        format: fieldFormat
    }, val, `raw`, formatOptions);
};
